export default "__VITE_ASSET__C$yYLe8x__"